module.exports = __webpack_public_path__ + "img/Cheer Megaphone41.13b74e48.jpg";